<script>
import { VideoPlayer } from 'vue-md-player'
import 'vue-md-player/dist/style.css'
export default {
  name: "VideoPage",
  components: { VideoPlayer },
  props: {
    src: String, // تعریف پارامتر src به عنوان props
  },
  setup(props) {

    return {
      // از مقدار props.src به صورت مستقیم استفاده کنید
      video_src: props.src,

    }
  }
}
</script>

<template>

  <div class="dialog max_width p-body">
    <video-player v-if="video_src !== null" class="" :autoplay="true" :double-click-fullscreen="true" :src="video_src"/>
  </div>

</template>

<style scoped>

</style>